/* FP cart delivery row v2 — behavior for snippets/fp-cart-delivery.liquid.
 *
 * EXTRACTED from the snippet's inline <script> (2026-07-13): the snippet only
 * renders when the cart has items, and inline <script> tags inserted by a
 * section morph never execute — so on a page served with an EMPTY cart the
 * delivery row stayed dead until a full reload. As an asset loaded by
 * sections/fp-cart-drawer.liquid it runs on every page with a drawer,
 * regardless of the cart state the page was rendered with.
 *
 * Load order matters: the section emits this tag AFTER component-cart-items.js,
 * so the cart:update listener below registers after the morphing listener and
 * paintAll() runs post-morph within the same dispatch (zero-flicker contract).
 */
(function () {
  'use strict';
  if (window.__fpCartDelivery) return;
  window.__fpCartDelivery = true;

  /* SAME key the PDP delivery block persists — one pincode across the site. */
  var KEY = 'fp_delivery_pincode';
  var DEFAULT_PIN = '395003'; /* Surat HQ — first-visit default (design lock) */
  var CUTOFF_HOUR = 15; /* 3 PM IST dispatch cutoff — matches theme.liquid enhancer */

  /* Real Blue Dart transit days, cached per pincode by the PDP block under
     'fp_delivery_tat_<assetVersion>'. The version suffix is unknowable here,
     so scan by prefix. Returns null when never looked up on a PDP. */
  function cachedTatDays(pin) {
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var k = localStorage.key(i);
        if (k && k.indexOf('fp_delivery_tat_') === 0) {
          var v = JSON.parse(localStorage.getItem(k) || '{}')[pin];
          if (typeof v === 'number' && isFinite(v) && v === Math.floor(v) && v >= 0 && v <= 15) return v;
        }
      }
    } catch (e) {}
    return null;
  }

  /* Transit days: real TAT when the PDP cached it; deterministic 2-4 day
     digit-sum fallback otherwise. +1 past the 3 PM IST dispatch cutoff.
     Swap for the courier-serviceability API when it lands. */
  function fpCartEtaDays(pin) {
    var days = cachedTatDays(pin);
    if (days == null) {
      var sum = 0;
      for (var i = 0; i < pin.length; i++) sum += Number(pin[i]);
      days = 2 + (sum % 3);
    }
    var nowIST = new Date(Date.now() + (330 + new Date().getTimezoneOffset()) * 60000);
    if (nowIST.getHours() >= CUTOFF_HOUR) days += 1;
    return days;
  }
  function etaLabel(days) {
    var d = new Date(Date.now() + days * 864e5);
    var W = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var M = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return W[d.getDay()] + ', ' + d.getDate() + ' ' + M[d.getMonth()];
  }
  function getPin() {
    try { return localStorage.getItem(KEY) || DEFAULT_PIN; } catch (e) { return DEFAULT_PIN; }
  }
  function setPin(v) {
    try { localStorage.setItem(KEY, v); } catch (e) {}
  }

  /* Change-guarded writes: paint() runs from a MutationObserver, so writing
     identical values back would re-trigger it forever. */
  function setText(el, v) { if (el && el.textContent !== v) el.textContent = v; }

  function paint(root) {
    var pin = getPin();
    setText(root.querySelector('[data-fp-delivery-pin]'), pin);
    setText(root.querySelector('[data-fp-delivery-eta]'), etaLabel(fpCartEtaDays(pin)));
    if (root.hidden) root.hidden = false;
  }

  function paintAll() {
    document.querySelectorAll('[data-fp-delivery]').forEach(paint);
  }

  /* All interaction DELEGATED at document level — section morphs can replace
     the row's DOM at any time and nothing needs re-wiring. */
  function commit(root) {
    var input = root.querySelector('[data-fp-delivery-input]');
    if (!input) return;
    var v = input.value.replace(/\D/g, '').slice(0, 6);
    if (v.length !== 6) { input.focus(); return; }
    setPin(v);
    paint(root);
    root.querySelector('[data-fp-delivery-edit]').hidden = true;
    root.querySelector('[data-fp-delivery-show]').hidden = false;
    try { if (typeof window.fpTrack === 'function') window.fpTrack('fp_cart_pincode_change', { fp_pin: v }); } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var root = t.closest('[data-fp-delivery]');
    if (!root) return;
    if (t.closest('[data-fp-delivery-change]')) {
      var input = root.querySelector('[data-fp-delivery-input]');
      if (input) input.value = getPin();
      root.querySelector('[data-fp-delivery-show]').hidden = true;
      root.querySelector('[data-fp-delivery-edit]').hidden = false;
      if (input) input.focus();
    } else if (t.closest('[data-fp-delivery-cancel]')) {
      root.querySelector('[data-fp-delivery-edit]').hidden = true;
      root.querySelector('[data-fp-delivery-show]').hidden = false;
    } else if (t.closest('[data-fp-delivery-check]')) {
      commit(root);
    }
  }, false);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var t = e.target;
    if (t && t.closest && t.closest('[data-fp-delivery-input]')) {
      e.preventDefault();
      var root = t.closest('[data-fp-delivery]');
      if (root) commit(root);
    }
  }, false);

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('[data-fp-delivery-input]')) {
      var clean = t.value.replace(/\D/g, '').slice(0, 6);
      if (t.value !== clean) t.value = clean;
    }
  }, false);

  /* ZERO-FLICKER REPAINT (2026-07-12): every cart morph re-renders the root
     with the server's `hidden` attr — repainting on a delay made the row
     blink on every qty change. The paint must run SYNCHRONOUSLY in the same
     dispatch as the morph, i.e. this cart:update listener must register
     AFTER cart-items-component's morphing listener. Both registration paths
     below satisfy that: as a defer script placed after component-cart-items.js
     the eval-time branch already runs post-module-eval, and a DCL-registered
     listener runs later still. The observer stays as a backstop for the
     page-load hydration morph (drawer closed — no visible flicker). */
  function registerPostMorph() {
    document.addEventListener('cart:update', function () { paintAll(); }, false);
    paintAll();
    installObserver();
  }

  function installObserver() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    var t2 = null;
    new MutationObserver(function () {
      if (t2) clearTimeout(t2);
      t2 = setTimeout(paintAll, 250);
    }).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', registerPostMorph);
  } else {
    registerPostMorph();
  }
})();
